import { FavouriteCondition, FavouriteDefinition, Value } from 'app/types-shared';
import { searchInAllFieldsDomain } from '../constants';

export const updateQueryCondition = (query: string, originalConditions: FavouriteCondition[] = []): FavouriteCondition[] => {

  return !!(originalConditions.length > 0 || query)
    ? [
      ...originalConditions.filter(c => (c.domain as Value).v !== searchInAllFieldsDomain),
      ...(!!query ?
        [{
          id: 0,
          domainDbFunction: {
            v: 0 // Not selected
          },
          domain: {
            v: searchInAllFieldsDomain // Search in all fields
          },
          valueOperator: {
            v: 2 // Or
          },
          conditionOperator: {
            v: 0 // Not selected
          },
          exactLevel: false,
          forceExists: false,
          values: [
            {
              id: 1,
              dbFunction: {
                v: 0 // Not selected
              },
              operator: {
                v: 14 // Equal
              },
              periodPredef: {
                v: 0 // Not selected
              },
              string: query,
              type: 'System.String'
            }
          ]
        }]
        : [])
    ]
    : [];
};

export const updateDefinitionWithQuery = (query: string) => (definition: FavouriteDefinition): FavouriteDefinition => ({
  ...definition,
  conditions: updateQueryCondition(query, definition.conditions)
});
